import React from 'react'
import { CaseStudyCardV2 } from '@/components/molecules/CaseStudyCardV2'
import './CaseStudySectionV2.css'

export interface CaseStudySectionV2Props {
  caseStudyV2: CaseStudyV2
  className?: string
}

export interface CaseStudyV2 {
  logoUrl?: string
  logoAlt?: string
  companyName: string
  headline: string
  imageUrl?: string
  imageAlt?: string
  tags: Array<{ label: string; iconUrl?: string; iconAlt?: string }>
  achievements: string[]
  cardClassName?: string
}

// Placeholder case study - user will provide actual data later
// const caseStudy: CaseStudyV2 = {
//   companyName: 'Properr',
//   headline: 'Increasing the marketing leads',
//   tags: [
//     { label: 'Design' },
//     { label: 'Development' }, // Icon can be added later via iconUrl property
//     { label: 'Trust building' },
//     { label: 'Gamification' },
//   ],
//   achievements: [
//     'Increased user trust through statistics.',
//     'Innovative pricing design to understand market inclination towards pricing.',
//     'Increased perceived value of the property by using anchoring. Compared the benefits with residential & commercial properties.',
//     'Designed multiple financing options based on the different financing problems faced by users.',
//   ],
// }

export const CaseStudySectionV2: React.FC<CaseStudySectionV2Props> = ({
  caseStudyV2,
  className = '',
}) => {
  return (
    <section className={`case-study-section-v2 ${className}`}>
      <CaseStudyCardV2
        logoUrl={caseStudyV2.logoUrl}
        logoAlt={caseStudyV2.logoAlt}
        companyName={caseStudyV2.companyName}
        headline={caseStudyV2.headline}
        imageUrl={caseStudyV2.imageUrl}
        imageAlt={caseStudyV2.imageAlt}
        tags={caseStudyV2.tags}
        achievements={caseStudyV2.achievements}
        className={caseStudyV2.cardClassName}
      />
    </section>
  )
}
